import React from 'react';
import PropTypes from 'prop-types';

import Cell from '../cell';

export default class Row extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    data: PropTypes.array,
    header: PropTypes.any,
    isGroupHeader: PropTypes.bool,
    isSummaryRow: PropTypes.bool,
  };

  static defaultProps = {
    className: '',
    data: null,
    header: null,
    isGroupHeader: false,
    isSummaryRow: false,
  };

  render() {
    const children = React.Children.toArray(this.props.children);
    let cellClassName = 'Table-Row--cell';
    if (this.props.isSummaryRow) {
      cellClassName += ' Table-Row--summary-cell';
    }

    if (this.props.data) {
      // Auto-generate children based on data row
      children.push(
        ...this.props.data.map((datum, index) => {
          let cellData;
          if (
            // an object that is not a react child component
            String(datum) === '[object Object]' &&
            !datum.hasOwnProperty('props')
          ) {
            cellData = datum;
          } else {
            cellData = {text: datum};
          }
          return (
            <Cell
              data={cellData}
              key={`Row--${index}--${cellData.text}`}
              tdAttributes={{
                className: cellClassName,
              }}
            />
          );
        }),
      );
    }

    if (this.props.header) {
      children.unshift(
        <th
          className={`Table-Row-header ${cellClassName}`}
          key={'header'}
          scope={'row'}>
          {this.props.header}
        </th>,
      );
    }

    let rowClassName = this.props.isGroupHeader
      ? 'Table-RowGroup'
      : 'Table-Row';

    if (this.props.isSummaryRow) {
      rowClassName += ' Table-Row--summary';
    }

    if (this.props.className) {
      rowClassName += ` ${this.props.className}`;
    }
    const row = <tr className={rowClassName}>{children}</tr>;

    return !this.props.isSummaryRow ? row : <tfoot>{row}</tfoot>;
  }
}
